module.exports = __webpack_public_path__ + "media/promo/courses/images/leaf-868757291bdb4724d50522d0530b61c5.png";